import request from '@/utils/request'

// 查询报价
export function queryAmount(data) {
  return request({
    url: '/quotationDetails/query',
    method: 'POST',
    data
  })
}

export function queryTransportPage(data) {
  return request({
    url: `/transport/queryTransportPage`,
    method: 'post',
    data
  })
}
//查询
export function querydeliveryPage(data) {
  return request({
    url: '/delivery/selectAll',
    method: 'POST',
    data
  })
}

// 查询所有数据
export function getAbroadList(data) {
  return request({
    url: '/freightCosts/selectAbroadList',
    method: 'POST',
    data
  })
}
export function queryportPage(data) {
  return request({
    url: '/port/selectAll',
    method: 'POST',
    data
  })
}

export function saveInfo(data) {
  return request({
    url: '/formalQuote/CustomerQuery/add',
    method: 'POST',
    data
  })
}
